import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';

export default function useCreateAccount() {
    const authenticatedApi = useAuthenticatedApi();

    const createAccount = async (userObject: any) => {
        const response = await authenticatedApi.post(
            '/accounts/create',
            JSON.stringify(userObject)
        );

        return response.status === 200;
    };

    return {
        createAccount,
    };
}
